import { IEvent } from '@src/interfaces';
import Classify from '@utils/Classify';
import React from 'react';
import { Form } from 'react-bootstrap';
import useValidation from '../../Hooks/useValidation';

interface Props {
  required?: boolean,
  name: string,
  title: string,
  value: string,
  setter: (value: string) => void,
  autoFocus?: boolean
}

const Email: React.FC<Props> = (props) => {

  const { isNotEmpty } = useValidation();

  const isValid = () => {
    return (!props.required && (!isNotEmpty(props.value) || isEmail(props.value))) || (props.required && isEmail(props.value));
  }

  const isEmail = (address: string | null): boolean => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test((String(address) || '').toLowerCase());
  }

  return (
    <Form.Group controlId={props.name} className={'form-group ' + Classify.addClassName(!isValid(), 'has-error')}>
      <Form.Label>{props.title}</Form.Label>
      <Form.Control
        isInvalid={!isValid()}
        type="text"
        value={props.value}
        onChange={(e: IEvent) => {
          props.setter(e.currentTarget.value);
        }}
      // autoFocus={!!props.autoFocus}
      />
    </Form.Group>
  );
}

export default Email;